const path = require('path');
const {
  CORE_SUPPORTED_LOCALES,
  CORE_DEFAULT_LOCALE,
  CORE_FALLBACK_LOCALE,
} = require('../../packages/app-i18n/src/core/locales');
const {
  createNextI18nextConfig,
} = require('../../packages/app-i18n/src/core/nextI18nextConfig');

module.exports = createNextI18nextConfig({
  locales: CORE_SUPPORTED_LOCALES,
  defaultLocale: CORE_DEFAULT_LOCALE,
  fallbackLng: CORE_FALLBACK_LOCALE,
  ns: [
    'accounts',
    'business',
    'common',
    'home',
    'layout',
    'manage',
    'store',
    'subscription',
    'wearables',
    'worldmodel',
  ],
  localeDetection: false,
  returnEmptyString: false,
  partialBundledLanguages: true,
  localePath: path.resolve('./public/locales'),
  reloadOnPrerender: process.env.NEXT_PUBLIC_STAGE === 'LOC',
});
